<template>
  <div class="add-tag-holder">
    <CreateTag v-if="!RMTStore.showAddGroup"/>
    <AddGroup v-if="RMTStore.showAddGroup"/>
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import { mapStores } from 'pinia/dist/pinia';

import AddGroup from '@/components/rmt/AddGroup';
import RightPanelButtons from '@/components/rmt/RightPanelButtons';
import CreateTag from '@/components/rmt/tag_matrix/CreateTag';

export default {
  name: 'TagManageOptions',
  components: {
    RightPanelButtons,
    CreateTag,
    AddGroup
  },
  props: [
    'mode'
  ],

  setup () {
    const RMTStore = useRMTStore();
    return {
      RMTStore
    };
  },
  computed: {
    ...mapStores(useRMTStore),
    showManageText () {
      return (!this.RMTStore.manageGroupMode) ? 'Manage Groups' : 'Done Managing Groups';
    },
    groupEditTitle () {
      return (!this.RMTStore.manageGroupMode) ? 'ADD GROUP' : 'EDIT GROUP';
    },
    editTag () {
      const RMTStore = useRMTStore();
      return RMTStore.editTag;
    },
    showAddGroup () {
      const RMTStore = useRMTStore();
      return RMTStore.showAddGroup;
    },
    selectedTagAddGroup: {
      get () {
        const RMTStore = useRMTStore();
        return RMTStore.selectedTagAddGroup;
      },
      set (value) {
        const RMTStore = useRMTStore();
        RMTStore.selectedTagAddGroup = value;
      }
    },
    groupData () {
      const RMTStore = useRMTStore();
      return RMTStore.groupData;
    }
  },

  mounted () {
    if (this.selectedTagAddGroup === null) {
      this.selectOptionAsGroup(this.groupData[0]);
    }
    if (this.editTag !== null) {
      this.$refs.tagName.value = this.editTag.name;
    }
  },
  methods: {

    selectOptionAsGroup (option) {
      this.message = '';
      if (this.RMTStore.manageGroupMode) { return; }
      this.selectedTagAddGroup = option;
    },
    deselectOptionAsGroup () {
      this.message = '';
      this.selectedTagAddGroup = null;
    },
    handleAddGroup () {
      this.RMTStore.showAddGroup = !this.RMTStore.showAddGroup;
    },
    handleGroupCancel () {
      this.RMTStore.showAddGroup = false;
    },
    handleCancelAddTag () {
      this.RMTStore.matrixMode = 'show';
    },
    handleGroupSave () {
      if (this.$refs.groupName.value === '') {
        this.message = 'Enter a group name';
        return;
      }
      const g = this.$refs.groupName.value;
      // edit
      if (this.RMTStore.manageGroupMode) {
        this.RMTStore.editGroup.groupName = this.$refs.groupName.value;
        this.updateGroup(this.RMTStore.editGroup);
      // create
      } else {
        this.updateGroup({
          groupId: 0,
          groupName: g,
          subscription: null,
          tagIds: []
        });
      }
      this.RMTStore.showAddGroup = false;
    },
    handleNameFocus () {
      this.message = '';
    },
    handleSaveTag () {
      if (this.$refs.tagName.value === '') {
        this.message = 'Enter a tag name.';
        return;
      }
      if (this.RMTStore.matrixMode === 'add') {
        this.RMTStore.createTag(
          {
            tag: this.$refs.tagName.value,
            color: '#ff0000',
            groupId: (this.selectedTagAddGroup !== null) ? this.selectedTagAddGroup.groupId : null
          }
        );
      }
      if (this.RMTStore.matrixMode === 'edit') {
        this.editTag.tag = this.$refs.tagName.value;
        this.editTag.groupId = (this.selectedTagAddGroup !== null) ? this.selectedTagAddGroup.groupId : null;
        this.RMTStore.updateTag(this.editTag);
      }
      this.RMTStore.matrixMode = 'show';
    },
    handleManageGroup () {
      this.RMTStore.manageGroupMode = !this.RMTStore.manageGroupMode;
    }
  }
};
</script>

<style scoped>
.add-tag-holder {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 400px;
  background-color: white;

}

</style>